import React from 'react';

import { EDropshippingProvider } from '@domain/enums/common/integrations/EDropshippingProvider';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';

import IntegrateForm from './IntegrateForm';
import YampiConfig from './YampiConfig';

const Yampi: React.FC = () => {
  const { storeIntegrations } = useStoreConfig();

  const { store_front } = storeIntegrations;

  const foundIntegration = store_front.find(
    integration => integration.name === EDropshippingProvider.YAMPI,
  );

  if (foundIntegration?.is_active) {
    return <YampiConfig />;
  }

  return <IntegrateForm />;
};

export default Yampi;
